const _window = $(window);
const body = $('body');
import Cursor from './cursor';

export let cursorElement;
export let customCursor;


if (!body.hasClass('is-safari') && matchMedia('(any-pointer:fine)').matches)
{
	/**
	 * Initialize custom cursor
	 */
	cursorElement = document.querySelector('.cursor');
	customCursor = new Cursor(cursorElement);


	/**
	 * Show a bigger cursor when over a link
	 */
	/*[...document.querySelectorAll('a')].forEach(
		(item, pos) => {

			item.addEventListener('mouseenter', function () {
				customCursor.enterActiveElement();
			});

			item.addEventListener('mouseleave', function () {
				customCursor.leaveActiveElement();
			});
		}
	);*/

	/**
	 * Change cursor color when over a colored background
	 */
	[...document.querySelectorAll('.cursor-scopri')].forEach(
		(item, pos) => {

			item.addEventListener('mouseenter', function () {
				cursorElement.classList.add('cursor--btn-scopri');
			});

			item.addEventListener('mouseleave', function () {
				cursorElement.classList.remove('cursor--btn-scopri');
			});
		}
	);

	[...document.querySelectorAll('.cursor-scopri-brand')].forEach(
		(item, pos) => {

			item.addEventListener('mouseenter', function () {
				cursorElement.classList.add('cursor--btn-scopri-brand');
			});

			item.addEventListener('mouseleave', function () {
				cursorElement.classList.remove('cursor--btn-scopri-brand');
			});
		}
	);
}